import { useUserStore } from "~/store/userStore";
import { useMaintenanceStore } from "~/store/maintenanceStore";
import md5 from "md5";
import { toast } from "vue3-toastify";

const requestOptions = {
  credentials: "include",
  onRequestError() {
    toast.error(_T("@Internal server error"), {
      autoClose: 2000,
    });
  },
  onResponse({ response }) {
    const xBuildtag = response.headers.get("x-build-tag");

    if (null !== xBuildtag && xBuildtag !== "B2C_250825") {
      reloadNuxtApp();
    }

    response._data = response._data.data ?? response._data;
  },
  onResponseError({ response }) {
    const userStore = useUserStore();

    if (response.status === 401) {
      userStore.fetch();
    }

    // if (!error.config.isAuthorized) {
    //
    // } else {
    //

    if (response.status === 429) {
      toast.error(_T("@Number of requests exceeded"), {
        autoClose: 2000,
      });
    }

    if (response.status === 503) {
      useMaintenanceStore().fetch();
    }

    if (response.status === 422) {
      return navigateTo({ name: getLocalizedRouteName("home") });
    }
  },
};

export const useAsyncPrivateAPI = async (url, options) => {
  const baseUrl = "/api";

  return useMyFetch(baseUrl + url, options);
};

export const useAsyncAPI = async (url, options) => {
  const config = useRuntimeConfig();
  const baseUrl = config.public.apiBaseUrl + "/user";

  return useMyFetch(baseUrl + url, options);
};

export const useMyFetch = async (url, options) => {
  const { data, status, error } = await useFetch(url, {
    ...options,
    ...requestOptions,
  });

  const hash = ref(null);

  if (options?.showError && null !== error.value) {
    throw showError({ statusCode: 404, statusMessage: "request error" });
  }

  if (options?.withHash) {
    hash.value = md5(JSON.stringify(data.value));
  }

  return reactive({
    data,
    status,
    hash,
  });
};

export const useAPI = (url, options) => {
  return $fetch(url, {
    ...options,
    ...requestOptions,
    baseURL: useRuntimeConfig().public.apiBaseUrl + "/user",
  });
};

export const useStrapiApi = async (url, requestOptions = {}) => {
  const defaultOptions = {
    timeout: 1000,
  };

  const { fallbackData = null, showError = false, ...options } = requestOptions;

  return $fetch(url, {
    ...defaultOptions,
    ...options,
    baseURL: useRuntimeConfig().public.strapiBaseUrl + "/api",
  }).catch(() => {
    if (!showError) {
      return {
        data: fallbackData,
      };
    }

    toast.error(_T("@Internal server error"), {
      autoClose: 2000,
    });
  });
};

export const useAsyncStrapiApi = (key, url, options) => {
  return useAsyncData(key, () => {
    return useStrapiApi(url, options);
  });
};
